<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content" v-if="project">
            <h1>Verbundprojekt bearbeiten<br>
                <small class="text-muted">{{project.name.text}}</small>
            </h1>
            <a :href="portalBaseUrl + '/' + store.state.language + '/umbrellaProjects/' + project.id" target="_blank"><i
                    class="fal fa-share"></i> Anzeigen</a>
            <br><br>
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <router-link class="nav-link"
                                 :to="{name: 'umbrella-project-edit', params: {projectId: $route.params.projectId}}"
                                 exact>Generelle Texte
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link"
                                 :to="{name: 'umbrella-project-edit-micropage', params: {projectId: $route.params.projectId}}"
                    >Micropage
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link"
                                 :to="{name: 'umbrella-project-edit-results', params: {projectId: $route.params.projectId}}">
                        Resultate
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link"
                                 :to="{name: 'umbrella-project-edit-projects', params: {projectId: $route.params.projectId}}"
                                 exact>Projekte
                    </router-link>
                </li>
            </ul>
            <div class="tab-content">
                <router-view class="tab-pane fade show active" :data="project" entity="umbrella_project"/>
            </div>
        </main>
        <loading v-else></loading>
    </div>
</template>
<script>
import moment from 'moment';

export default {
  data() {},
  methods: {},
  computed: {
    portalBaseUrl: function() {
      return portalBaseUrl;
    },
    store: function() {
      return store;
    }
  },
  asyncComputed: {
    project() {
      let promises = [];
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/umbrella_project/" +
            this.$route.params.projectId
        )
      );
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/umbrella_project/" +
            this.$route.params.projectId +
            "/results"
        )
      );
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/umbrella_project/" +
            this.$route.params.projectId +
            "/blocks"
        )
      );
      promises.push(
        axios.get("/api/" + store.state.language + "/project/list")
      );
      return Promise.all(promises).then(responses => {
        let project = responses[0].data.result;
        project.results = responses[1].data.result;
        project.blocks = responses[2].data.result;
        project.projects = responses[3].data.result.filter(p =>
          project.projectIds.includes(p.id)
        );

        if (project.disclaimerDate)
          project.disclaimerDate = moment(project.disclaimerDate.date);

        return project;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/umbrella_project/Edit.vue